import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { MouseTarget } from '../controller/mouseTarget.js';
export var ViewUserInputEvents = /*#__PURE__*/function () {
  function ViewUserInputEvents(coordinatesConverter) {
    _classCallCheck(this, ViewUserInputEvents);

    this.onKeyDown = null;
    this.onKeyUp = null;
    this.onContextMenu = null;
    this.onMouseMove = null;
    this.onMouseLeave = null;
    this.onMouseDown = null;
    this.onMouseUp = null;
    this.onMouseDrag = null;
    this.onMouseDrop = null;
    this.onMouseWheel = null;
    this._coordinatesConverter = coordinatesConverter;
  }

  _createClass(ViewUserInputEvents, [{
    key: "emitKeyDown",
    value: function emitKeyDown(e) {
      if (this.onKeyDown) {
        this.onKeyDown(e);
      }
    }
  }, {
    key: "emitKeyUp",
    value: function emitKeyUp(e) {
      if (this.onKeyUp) {
        this.onKeyUp(e);
      }
    }
  }, {
    key: "emitContextMenu",
    value: function emitContextMenu(e) {
      if (this.onContextMenu) {
        this.onContextMenu(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseMove",
    value: function emitMouseMove(e) {
      if (this.onMouseMove) {
        this.onMouseMove(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseLeave",
    value: function emitMouseLeave(e) {
      if (this.onMouseLeave) {
        this.onMouseLeave(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseDown",
    value: function emitMouseDown(e) {
      if (this.onMouseDown) {
        this.onMouseDown(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseUp",
    value: function emitMouseUp(e) {
      if (this.onMouseUp) {
        this.onMouseUp(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseDrag",
    value: function emitMouseDrag(e) {
      if (this.onMouseDrag) {
        this.onMouseDrag(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseDrop",
    value: function emitMouseDrop(e) {
      if (this.onMouseDrop) {
        this.onMouseDrop(this._convertViewToModelMouseEvent(e));
      }
    }
  }, {
    key: "emitMouseWheel",
    value: function emitMouseWheel(e) {
      if (this.onMouseWheel) {
        this.onMouseWheel(e);
      }
    }
  }, {
    key: "_convertViewToModelMouseEvent",
    value: function _convertViewToModelMouseEvent(e) {
      if (e.target) {
        return {
          event: e.event,
          target: this._convertViewToModelMouseTarget(e.target)
        };
      }

      return e;
    }
  }, {
    key: "_convertViewToModelMouseTarget",
    value: function _convertViewToModelMouseTarget(target) {
      return ViewUserInputEvents.convertViewToModelMouseTarget(target, this._coordinatesConverter);
    }
  }], [{
    key: "convertViewToModelMouseTarget",
    value: function convertViewToModelMouseTarget(target, coordinatesConverter) {
      return new ExternalMouseTarget(target.element, target.type, target.mouseColumn, target.position ? coordinatesConverter.convertViewPositionToModelPosition(target.position) : null, target.range ? coordinatesConverter.convertViewRangeToModelRange(target.range) : null, target.detail);
    }
  }]);

  return ViewUserInputEvents;
}();

var ExternalMouseTarget = /*#__PURE__*/function () {
  function ExternalMouseTarget(element, type, mouseColumn, position, range, detail) {
    _classCallCheck(this, ExternalMouseTarget);

    this.element = element;
    this.type = type;
    this.mouseColumn = mouseColumn;
    this.position = position;
    this.range = range;
    this.detail = detail;
  }

  _createClass(ExternalMouseTarget, [{
    key: "toString",
    value: function toString() {
      return MouseTarget.toString(this);
    }
  }]);

  return ExternalMouseTarget;
}();